import platformAccess from './platform-access';
import platformComponents from './platform-components';
import userData from './user-data';

export default {
  platformAccess,
  platformComponents,
  userData,
};
